import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import useWorkspaceNavigate from "common/hooks/useWorkspaceNavigate";

import useCampaignMutations from "../../datahooks/useCampaignMutations";

interface DeleteCampaignProps {
  campaignName: string;
  campaignId: string;
  onClose: () => void;
  onCancel: () => void;
}

export default function DeleteCampaign({
  campaignName,
  campaignId,
  onClose,
  onCancel,
}: DeleteCampaignProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { deleteCampaign, isDeletingCampaign } = useCampaignMutations();
  const { relativeNavigate } = useWorkspaceNavigate();

  function onDelete() {
    deleteCampaign({ campaignId }).then(() => {
      onClose();
      relativeNavigate("campaigns");
    });
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="Delete Campaign"
        subtitle={
          <>
            Are you sure you want to delete campaign &quot;
            {campaignName}
            &quot;?
          </>
        }
      />

      <Footer className="items-center justify-end">
        <Button
          variant="secondary-black"
          onClick={onCancel}
          disabled={isDeletingCampaign}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          onClick={onDelete}
          isLoading={isDeletingCampaign}
        >
          Delete
        </Button>
      </Footer>
    </>
  );
}
